"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var createConnect_1 = require("./createConnect");
exports.default = createConnect_1.default({
    field: 'suggestions',
    handlers: {
        getSuggestionProps: function (_a) {
            var update = _a.update, analytics = _a.analytics, meta = _a.meta, suggestions = _a.suggestions;
            return function (index, widgetKey) {
                if (widgetKey === void 0) { widgetKey = ''; }
                var value = suggestions.getIn([index, 'value']);
                return {
                    key: value,
                    onClick: function (e) {
                        if (e)
                            e.preventDefault();
                        update('q', value);
                        analytics.sendEvent('click-suggestion', {
                            suggestion: value,
                            rid: meta.get('rid'),
                        });
                        window.findify.emit('autocompleteFocusLost', widgetKey);
                        window.findify.emit('search', widgetKey, value);
                    }
                };
            };
        }
    }
});
//# sourceMappingURL=connectSuggestions.js.map